var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceSynonym(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e,.f{fill:#fff;}.a{opacity:0;}.b,.d{fill:#bdedf8;}.b,.c,.e,.g{fill-rule:evenodd;}.c{fill:#428bca;}.g,.h{fill:#66ceef;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15556 12608)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 80,
    height: 80,
    transform: "translate(-15556 -12608)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17291.455 -14048.951)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1790.969,1456.061v45.951l-19.516-3.45v-45.947Z",
    transform: "translate(9.708 1.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1772.023,1498.328l18.641,3.289v-45.057l-18.641-3.293v45.061Zm19.073,4.251a.622.622,0,0,1-.074-.007l-19.516-3.446a.438.438,0,0,1-.358-.432v-45.947a.426.426,0,0,1,.149-.337.44.44,0,0,1,.358-.1l19.516,3.451a.438.438,0,0,1,.372.428v45.951a.459.459,0,0,1-.161.336A.482.482,0,0,1,1791.1,1502.579Z",
    transform: "translate(9.58 0.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1774.627,1452.616v45.947l-10.693,11.782V1464.4Z",
    transform: "translate(6.534 1.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1764.5,1464.693v44.649l9.828-10.816v-44.643l-9.828,10.811Zm-.432,46.222a.49.49,0,0,1-.161-.031.436.436,0,0,1-.283-.41v-45.947a.444.444,0,0,1,.122-.3l10.69-11.781a.436.436,0,0,1,.484-.111.429.429,0,0,1,.283.407v45.947a.425.425,0,0,1-.122.293l-10.69,11.782A.439.439,0,0,1,1764.066,1510.915Z",
    transform: "translate(6.402 0.995)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 21.569,
    height: 45.949,
    transform: "translate(1748.898 1465.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1749.331,1506.538h20.693v-45.072h-20.693v45.072Zm21.137.88H1748.9a.442.442,0,0,1-.444-.441v-45.947a.441.441,0,0,1,.444-.441h21.569a.44.44,0,0,1,.432.441v45.947A.44.44,0,0,1,1770.468,1507.419Z",
    transform: "translate(0 4.491)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1785.695,1452.943v45.948l-.519,2.984v-45.951Z",
    transform: "translate(15.501 1.263)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1785.752,1502Zm-.448.435h-.037a.441.441,0,0,1-.4-.435v-45.951l.518-3.056a.455.455,0,0,1,.471-.36.438.438,0,0,1,.409.435v45.947l-.532,3.061A.44.44,0,0,1,1785.3,1502.44Z",
    transform: "translate(15.372 1.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1800.545,1457.057l-19.516-3.446-10.693,11.781h-21.569v-3.029h19.8l10.875-12.106,21.617,3.819Z",
    transform: "translate(0.132 0.129)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1749.331,1465.08h20.939l10.566-11.636a.445.445,0,0,1,.4-.138l19.083,3.373.371-2.117-20.953-3.7-10.716,11.923a.434.434,0,0,1-.318.144h-19.372v2.15Zm21.137.876H1748.9a.437.437,0,0,1-.444-.435v-3.029a.437.437,0,0,1,.444-.437h19.6l10.745-11.96a.461.461,0,0,1,.407-.138l21.618,3.815a.429.429,0,0,1,.358.511l-.518,2.981a.439.439,0,0,1-.186.279.426.426,0,0,1-.321.075l-19.283-3.406-10.529,11.6A.451.451,0,0,1,1770.468,1465.957Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1790.969,1489.086v3.6l-7.552-1.334v8.871l-3.4-.6v-8.875l-8.566-1.512v-3.6l8.566,1.513v-15.528l-8.566-1.51v-3.6l8.566,1.512v-14.345l3.4.6v14.345l7.552,1.334v3.6l-7.552-1.331v15.526Z",
    transform: "translate(9.708 1.573)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1780.58,1499.392l2.533.442v-8.349a.425.425,0,0,1,.148-.336.436.436,0,0,1,.36-.1l7.044,1.24v-2.709l-7.195-1.271a.434.434,0,0,1-.357-.432v-15.525a.421.421,0,0,1,.148-.334.439.439,0,0,1,.36-.1l7.044,1.241v-2.709l-7.195-1.27a.436.436,0,0,1-.357-.432v-13.976l-2.533-.446v13.823a.439.439,0,0,1-.162.334.447.447,0,0,1-.356.1l-8.039-1.424v2.712l8.2,1.449a.431.431,0,0,1,.358.429v15.53a.459.459,0,0,1-.162.336.425.425,0,0,1-.356.092l-8.039-1.419V1489l8.2,1.451a.431.431,0,0,1,.358.428v8.51Zm2.965,1.4c-.027,0-.048,0-.075,0l-3.407-.6a.444.444,0,0,1-.363-.432v-8.506l-8.193-1.449a.437.437,0,0,1-.358-.432v-3.6a.429.429,0,0,1,.508-.432l8.043,1.424v-14.639l-8.193-1.449a.429.429,0,0,1-.358-.428v-3.6a.426.426,0,0,1,.149-.336.444.444,0,0,1,.358-.1l8.043,1.423v-13.823a.441.441,0,0,1,.159-.334.448.448,0,0,1,.363-.1l3.4.6a.447.447,0,0,1,.371.432v13.979l7.18,1.267a.445.445,0,0,1,.372.432v3.6a.457.457,0,0,1-.161.337.465.465,0,0,1-.361.094l-7.031-1.24v14.639l7.18,1.27a.44.44,0,0,1,.372.43v3.6a.456.456,0,0,1-.161.334.443.443,0,0,1-.361.092l-7.031-1.24v8.349a.464.464,0,0,1-.161.34A.5.5,0,0,1,1783.545,1500.8Z",
    transform: "translate(9.58 1.443)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 21.569,
    height: 3.603,
    transform: "translate(1748.898 1498.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1749.331,1487.727h20.693V1485h-20.693v2.725Zm21.137.879H1748.9a.441.441,0,0,1-.444-.438v-3.6a.441.441,0,0,1,.444-.441h21.569a.439.439,0,0,1,.432.441v3.6A.439.439,0,0,1,1770.468,1488.606Z",
    transform: "translate(0 14.426)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1774.627,1466.01v3.6l-10.693,11.777v-3.6l5.354-5.89v-14.345l2.433-2.69v14.345Z",
    transform: "translate(6.534 2.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1764.5,1478.09v2.3l9.828-10.817v-2.3l-2.154,2.363a.431.431,0,0,1-.753-.3v-13.207l-1.568,1.722v14.176a.432.432,0,0,1-.111.294l-5.242,5.765Zm-.432,3.87a.494.494,0,0,1-.161-.03.439.439,0,0,1-.283-.408v-3.6a.44.44,0,0,1,.122-.294l5.229-5.767v-14.174a.438.438,0,0,1,.109-.294l2.449-2.689a.438.438,0,0,1,.481-.115.449.449,0,0,1,.272.409v13.211l2.15-2.362a.439.439,0,0,1,.484-.112.432.432,0,0,1,.283.407v3.6a.451.451,0,0,1-.122.294l-10.69,11.776A.443.443,0,0,1,1764.066,1481.959Z",
    transform: "translate(6.402 1.944)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1770.336,1475.243v3.6h-10.1v8.111h10.1v3.078h-12.251v-11.189h-9.318v-3.6h9.318V1460.9h2.154v14.344Z",
    transform: "translate(0.132 4.621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1758.653,1489.723h11.371v-2.2h-9.653a.44.44,0,0,1-.434-.437v-8.11a.44.44,0,0,1,.434-.441h9.653v-2.723h-9.653a.437.437,0,0,1-.434-.437v-13.908h-1.284v13.908a.436.436,0,0,1-.437.437h-8.885v2.723h8.885a.44.44,0,0,1,.437.441v10.749Zm11.815.876h-12.252a.437.437,0,0,1-.442-.437v-10.75H1748.9a.439.439,0,0,1-.444-.438v-3.6a.441.441,0,0,1,.444-.439h8.876v-13.9a.441.441,0,0,1,.442-.441h2.155a.443.443,0,0,1,.444.441v13.9h9.653a.439.439,0,0,1,.432.439v3.6a.438.438,0,0,1-.432.438h-9.653v7.233h9.653a.436.436,0,0,1,.432.439v3.078A.436.436,0,0,1,1770.468,1490.6Z",
    transform: "translate(0 4.491)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1770.584,1474.065v7.421l4.043-4.451v3.6l-4.043,4.453v8.874l-1.3,1.442v-8.874l-5.354,5.887v-3.6l5.354-5.892v-4.34l-5.354,5.89V1481.4Z",
    transform: "translate(6.534 10.179)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1769.42,1486.217a.36.36,0,0,1,.145.03.435.435,0,0,1,.286.411v7.739l.432-.474v-8.708a.431.431,0,0,1,.112-.294l3.931-4.326v-2.3l-3.291,3.611a.424.424,0,0,1-.479.115.449.449,0,0,1-.273-.411v-6.284l-5.785,6.364v1.773l4.585-5.049a.445.445,0,0,1,.482-.115.436.436,0,0,1,.286.41v4.34a.437.437,0,0,1-.111.294l-5.242,5.764v2.3l4.585-5.05a.446.446,0,0,1,.337-.145Zm0,9.752a.423.423,0,0,1-.16-.03.434.434,0,0,1-.286-.407v-7.742l-4.585,5.049a.447.447,0,0,1-.484.116.439.439,0,0,1-.283-.41v-3.6a.448.448,0,0,1,.122-.3l5.229-5.764v-3.04l-4.585,5.054a.443.443,0,0,1-.767-.3v-3.078a.445.445,0,0,1,.122-.3l6.651-7.329a.433.433,0,0,1,.481-.111.438.438,0,0,1,.287.405v6.286l3.271-3.611a.44.44,0,0,1,.767.294v3.6a.443.443,0,0,1-.122.3l-3.915,4.326v8.7a.451.451,0,0,1-.128.3l-1.3,1.438A.453.453,0,0,1,1769.42,1495.968Z",
    transform: "translate(6.402 10.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1771.453,1452.616l8.566,1.511v14.345l-8.566-1.513Z",
    transform: "translate(9.708 1.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1772.023,1466.72l7.677,1.361v-13.453l-7.677-1.361v13.453Zm8.123,2.318a.777.777,0,0,1-.084,0l-8.555-1.513a.437.437,0,0,1-.358-.432v-14.344a.426.426,0,0,1,.149-.337.44.44,0,0,1,.358-.1l8.565,1.513a.439.439,0,0,1,.358.432V1468.6a.438.438,0,0,1-.162.334A.4.4,0,0,1,1780.147,1469.038Z",
    transform: "translate(9.58 0.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1771.453,1465.236l8.566,1.51v15.528l-8.566-1.513Z",
    transform: "translate(9.708 6.452)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1772.023,1480.522l7.677,1.357v-14.635l-7.677-1.357v14.635Zm8.123,2.318a.326.326,0,0,1-.084-.007l-8.555-1.509a.437.437,0,0,1-.358-.432v-15.525a.426.426,0,0,1,.508-.434l8.565,1.513a.431.431,0,0,1,.358.429v15.53a.458.458,0,0,1-.162.336A.4.4,0,0,1,1780.147,1482.84Z",
    transform: "translate(9.58 6.321)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 10.099,
    height: 8.11,
    transform: "translate(1760.37 1483.466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1757.406,1481.32h9.209v-7.233h-9.209v7.233Zm9.653.876h-10.1a.44.44,0,0,1-.434-.437v-8.11a.44.44,0,0,1,.434-.441h10.1a.439.439,0,0,1,.432.441v8.11A.439.439,0,0,1,1767.06,1482.2Z",
    transform: "translate(3.408 9.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1769.41,1455.815l2.906-3.2v14.344l-2.906,3.2Z",
    transform: "translate(8.845 1.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1769.97,1456.118v13.039l2.042-2.236v-13.039l-2.042,2.235Zm-.431,14.611a.52.52,0,0,1-.161-.029.429.429,0,0,1-.273-.411v-14.344a.438.438,0,0,1,.112-.294l2.9-3.2a.436.436,0,0,1,.484-.111.429.429,0,0,1,.283.407v14.343a.449.449,0,0,1-.122.295l-2.907,3.2A.43.43,0,0,1,1769.539,1470.729Z",
    transform: "translate(8.717 0.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1770.584,1469.685l4.043-4.449v15.525l-4.043,4.452v-7.422l-6.65,7.333v-8.111Z",
    transform: "translate(6.534 6.452)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1770.715,1469.815h0Zm0,7.672a.374.374,0,0,1,.161.03.438.438,0,0,1,.287.405v6.286l3.163-3.483V1466.5l-3.291,3.615h0l-6.537,7.2v6.8l5.9-6.49a.423.423,0,0,1,.32-.141Zm0,8.294a.548.548,0,0,1-.159-.027.449.449,0,0,1-.273-.411v-6.284l-5.895,6.488a.441.441,0,0,1-.767-.292v-8.11a.449.449,0,0,1,.122-.3l10.69-11.781a.444.444,0,0,1,.484-.112.436.436,0,0,1,.283.411v15.525a.45.45,0,0,1-.122.295l-4.043,4.453A.409.409,0,0,1,1770.715,1485.781Z",
    transform: "translate(6.402 6.321)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 21.569,
    height: 8.874,
    transform: "translate(1748.898 1502.595)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1749.331,1495.534h20.693v-8h-20.693v8Zm21.137.88H1748.9a.442.442,0,0,1-.444-.441V1487.1a.441.441,0,0,1,.444-.441h21.569a.439.439,0,0,1,.432.441v8.874A.44.44,0,0,1,1770.468,1496.415Z",
    transform: "translate(0 15.495)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 9.32,
    height: 14.344,
    transform: "translate(1748.898 1465.521)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1749.331,1474.935h8.443v-13.469h-8.443v13.469Zm8.885.876H1748.9a.437.437,0,0,1-.444-.437v-14.343a.441.441,0,0,1,.444-.441h9.318a.44.44,0,0,1,.437.441v14.343A.436.436,0,0,1,1758.216,1475.811Z",
    transform: "translate(0 4.491)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1769.288,1482.829l-5.354,5.887v8.875l5.354-5.887Z",
    transform: "translate(6.534 13.878)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1764.5,1489.013v7.575l4.475-4.926v-7.572l-4.475,4.922Zm-.432,9.148a.493.493,0,0,1-.161-.031.437.437,0,0,1-.283-.41v-8.874a.44.44,0,0,1,.122-.294l5.339-5.889a.447.447,0,0,1,.482-.115.434.434,0,0,1,.286.411v8.874a.427.427,0,0,1-.111.292l-5.351,5.89A.438.438,0,0,1,1764.066,1498.162Z",
    transform: "translate(6.402 13.748)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1779.865,1480.172l7.552,1.334v8.874l-7.552-1.337Z",
    transform: "translate(13.259 12.757)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1780.441,1488.809l6.672,1.176V1482l-6.672-1.177v7.985Zm7.1,2.137a.6.6,0,0,1-.074-.007l-7.553-1.329a.44.44,0,0,1-.357-.437V1480.3a.425.425,0,0,1,.148-.336.437.437,0,0,1,.36-.1l7.552,1.334a.443.443,0,0,1,.372.432v8.874a.46.46,0,0,1-.161.336A.483.483,0,0,1,1787.546,1490.947Z",
    transform: "translate(13.131 12.626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceSynonym);
export default __webpack_public_path__ + "static/media/place_synonym.95c64aaf4b365340dae8e493c63f4ea1.svg";
export { ForwardRef as ReactComponent };